import imageUrlBuilder from '@sanity/image-url';

import sanityClient from './sanityClient';

const builder = imageUrlBuilder(sanityClient);

const sanityImageBuilder = (source: string) => builder.image(source);

export default sanityImageBuilder;

export const getSanityImageUrl = (url: string, params: { width: number; height: number; quality?: number }): string => {
  return (
    sanityImageBuilder(url)
      .width(params.width)
      .height(params.height)
      .quality(params.quality || 90)
      .url() || ''
  );
};
